module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"overview":"Overview","communication":"Communication","financials":"Financials","terms":"Terms"},"et":{"overview":"Overview","communication":"Communication","financials":"Financials","terms":"Terms"},"ru":{"overview":"Overview","communication":"Communication","financials":"Financials","terms":"Terms"}}')
  delete Component.options._Ctor
}
